module.exports = __webpack_public_path__ + "assets/media/evening.60ba9bf8.mp3";